import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "absolute ltr:-right-[95px] rtl:-left-[95px] -bottom-[35px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center justify-between\"><span class=\"inline-block px-[8.5px] text-success-700 border border-success-300 bg-success-100 text-sm rounded-[100px] text-xs\"> +75% </span><span class=\"block text-xs\"> Last 30 days </span></div><div class=\"h-[70px]\"></div><span class=\"block mb-[4px]\"> Properties for Sale </span><h3 class=\"mb-0 text-[20px]\">5,458</h3>", 4)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: "170",
              options: _ctx.propertiesForSale,
              series: _ctx.sale
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}